import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

// Define injection tokens for Angular 17 SSR
export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  cookies: string = '';
  document: any = { cookie: '' };

  constructor(
    @Optional() @Inject(REQUEST) private req: Request,
    @Optional() @Inject(RESPONSE) private res: Response,
  ) {
    if (this.req?.headers) {
      this.cookies = this.req.headers.cookie || '';
    } else if (typeof document !== 'undefined') {
      this.document = document;
    }
  }

  getItem(name: string): string | null {
    if (!this.cookies && !this.document?.cookie) {
      return null;
    }
    const cookies = this._getPairs();
    return cookies[name] || null;
  }

  setItem(
    name: string,
    value: string,
    expiry?: Date | string,
    path: string = '/',
  ): boolean {
    if (!name) return false;

    if (!this.req) {
      if (typeof document !== 'undefined') {
        let expiryStr = '';
        if (expiry) {
          if (!(expiry instanceof Date)) {
            expiry = new Date(expiry);
          }
          expiryStr = '; expires=' + expiry.toUTCString();
        }
        document.cookie = `${name}=${value}${expiryStr}; path=${path}; Secure; SameSite=None`;
      }
    } else if (this.res) {
      const options: any = { path, encode: String };
      if (expiry) {
        if (!(expiry instanceof Date)) {
          expiry = new Date(expiry);
        }
        const now = new Date();
        if (expiry.getTime() <= now.getTime()) {
          return this.removeItem(name, path);
        }
        options.expires = expiry;
      }
      this.res.cookie(name, value, options);
    }

    return true;
  }

  removeItem(name: string, path: string = '/'): boolean {
    if (!name) return false;

    if (!this.req) {
      if (typeof document !== 'undefined') {
        document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    } else if (this.res) {
      this.res.cookie(name, '', { path, expires: new Date(0), encode: String });
    }

    return true;
  }

  private _getPairs(): { [key: string]: string | null } {
    const source = this.req
      ? this.cookies
      : typeof document !== 'undefined'
        ? this.document.cookie
        : '';
    const parsed = source.split('; ');
    const cookies: { [key: string]: string | null } = {};

    parsed.forEach((element: string) => {
      if (element) {
        const index = element.indexOf('=');
        const key = element.slice(0, index);
        const value = element.slice(index + 1);
        cookies[key] = value || null;
      }
    });

    return cookies;
  }
}
